import React from 'react';
import rlookEventsLogo from '@/assets/rlook_events.png';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
}

export const RecruitLookLogo: React.FC<LogoProps> = ({ className = '', size = 'md' }) => {
  const sizeClasses = {
    sm: 'h-8',
    md: 'h-10',
    lg: 'h-12',
    xl: 'h-16'
  };

  return (
    <img 
      src={rlookEventsLogo} 
      alt="RecruitLook Events Logo" 
      className={`${sizeClasses[size]} w-auto ${className}`}
    />
  );
};